import { c as _c } from "react/compiler-runtime";
// Third Party
import * as React from 'react';
import { motion } from 'framer-motion';
import { twMerge } from 'tailwind-merge';
import { Disclosure, DisclosureButton, DisclosurePanel, Transition } from '@headlessui/react';

// UI
import { Typography } from '@components/typography';
import { getTypographyStylesAsClassName } from '@components/typography/typography-styles';
import { Icon, IconNames } from '@components/icon';
const faqs = [{
  question: 'How many friends can I refer?',
  answer: 'Refer as many friends as you want. Cash back rewards apply to your first 5 completed referrals.'
}, {
  question: 'How do I redeem my cash back?',
  isHtml: true,
  answer: "Your $50 bonus is issued as a cash-back rebate after you book your first stay through Savvy. Here's the process:<br /><br />" + "1. <strong>Book your stay</strong> on Savvy or directly through the host's website, pay in full, and hold onto your receipt.<br />" + '2. <strong>Submit your rebate</strong> using our rebate redemption form — just enter your booking details and upload your receipt. <a href="https://finderco.my.site.com/help/s/savvy-gift-cards/promotion" target="_blank" rel="noopener noreferrer">Submit Your Rebate Here</a>.<br />' + "3. <strong>Get your cash back</strong> — once approved, you'll receive a secure link to choose how you'd like to be paid: ACH transfer, debit card, Venmo, CashApp, or PayPal.<br /><br />" + 'Rebates are typically processed by the next business day after approval.'
}, {
  question: 'When do I get my $50 cash back?',
  answer: 'After you book your stay, and have submitted your reimbursement your cash back is processed by the next business day after approval.'
}, {
  question: 'Can I stack this with other offers?',
  answer: "You can combine multiple referral rewards (up to 5). The referral offer itself can't be combined with other promotions."
}, {
  question: 'Can I pool my cash back with friends or family?',
  answer: 'Cash back stays with the account that earned it. No transfers, no pooling.'
}];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.08
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.4
    }
  }
};
const inViewViewport = {
  once: true,
  margin: '-50px'
} as const;
export const FAQSection: React.FC = () => {
  const $ = _c(4);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      opacity: 0,
      y: 20
    };
    t1 = {
      opacity: 1,
      y: 0
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <motion.div initial={t0} whileInView={t1} viewport={inViewViewport} transition={{
      duration: 0.5
    }}><Typography variant="title4" component="h2" className="text-center mb-4 ">FAQs</Typography></motion.div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div id="faqs" className="py-12 bg-white"><div className="body-container max-w-5xl mx-auto">{t2}<motion.div className="space-y-3" initial="hidden" whileInView="visible" viewport={inViewViewport} variants={containerVariants}>{faqs.map(_temp)}</motion.div></div></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
};
function _temp(faq, index) {
  return <motion.div key={index} variants={itemVariants}><Disclosure>{t0 => {
        const {
          open
        } = t0;
        return <div className="bg-off-white rounded-2xl overflow-hidden shadow-sm"><DisclosureButton className="flex justify-between items-center w-full text-left px-6 py-5 hover:bg-gray-xxlight transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary-main focus-visible:ring-inset" aria-expanded={open}><Typography variant="body1" component="span" className="font-medium text-primary-main pr-4">{faq.question}</Typography><motion.div animate={{
              rotate: open ? 180 : 0
            }} transition={{
              duration: 0.2
            }} className="flex-shrink-0"><Icon name={IconNames.CHEVRON_DOWN} className="w-5 h-5 text-primary-main/60" /></motion.div></DisclosureButton><Transition enter="transition-all duration-200 ease-out" enterFrom="opacity-0 max-h-0" enterTo="opacity-100 max-h-96" leave="transition-all duration-150 ease-in" leaveFrom="opacity-100 max-h-96" leaveTo="opacity-0 max-h-0"><DisclosurePanel className="px-6 pb-5 pt-0 overflow-hidden"><div className="border-t border-gray-xlight pt-4">{"isHtml" in faq && faq.isHtml ? <div className={twMerge(getTypographyStylesAsClassName("body2"), "text-primary-main/75 leading-relaxed [&_a]:underline [&_a]:hover:opacity-80 [&_a]:text-primary-main [&_a]:font-medium")} dangerouslySetInnerHTML={{
                  __html: faq.answer
                }} /> : <Typography variant="body2" component="p" className="text-primary-main/75 leading-relaxed">{faq.answer}</Typography>}</div></DisclosurePanel></Transition></div>;
      }}</Disclosure></motion.div>;
}